import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_create_improvement_plans_based_on_social_and_labor'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_create_improvement_plans_based_on_social_and_labor',
  name: 'Does the facility create improvement plans based on social and labor practices?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PLANS_ARE_CREATED_BASED_ON_ISSUES_UNCOVERED_THROUGH_MONITORING_',
      text: 'Plans are created based on issues uncovered through monitoring and evaluation',
      externalIds: [
        {
          id: 'ms-7-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLANS_INCLUDE_ROOT_CAUSE_ANALYSIS_RCA_',
      text: 'Plans include root cause analysis (RCA)',
      externalIds: [
        {
          id: 'ms-7-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLANS_INCLUDE_GRIEVANCES_AND_SUGGESTIONS_RAISED_BY_WORKERS',
      text: 'Plans include grievances and suggestions raised by workers',
      externalIds: [
        {
          id: 'ms-7-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLANS_ARE_COMPLETED_AND_THE_RELATED_ISSUES_RESOLVED',
      text: 'Plans are completed and the related issues resolved',
      externalIds: [
        {
          id: 'ms-7-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WRITTEN_RECORDS_ARE_MAINTAINED',
      text: 'Written records are maintained',
      externalIds: [
        {
          id: 'ms-7-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-7-6x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-7-6f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PLANS_ARE_CREATED_BASED_ON_ISSUES_UNCOVERED_THROUGH_MONITORING_',
                'PLANS_INCLUDE_ROOT_CAUSE_ANALYSIS_RCA_',
                'PLANS_INCLUDE_GRIEVANCES_AND_SUGGESTIONS_RAISED_BY_WORKERS',
                'PLANS_ARE_COMPLETED_AND_THE_RELATED_ISSUES_RESOLVED',
                'WRITTEN_RECORDS_ARE_MAINTAINED',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-act-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 23790,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
